import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import { useParams, useLocation } from "react-router-dom";
import axios from "../../services/axios";
import slugify from "slugify";

function Radio({
  onBlurHandler,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  editable,
  tokenType,
  errorInputs,
}) {
  const { id, ids, candidateId: cID } = useParams();
  const formId = id;
  const candidateId = ids || cID;
  const [defValue, setDefValue] = useState("");

  const [element, setElement] = useState({
    type: "radio",
    properties: {
      label: "Radio question field.",
      options: [],
      columns: 1,
    },
    required: false,
  });

  const [readOnly, setReadOnly] = useState(false);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    setStatus(data.properties.value);
    setElement((prev) => ({ ...prev, ...data }));
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }

    //check prefilled field -Lovejot(07-DEC-2022)
    if (
      data?.properties.disableField === true &&
      data?.properties?.value &&
      data?.properties?.value?.length !== 0 &&
      localStorage.getItem("user.role") !== "admin"
    ) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [data, data.properties.value, isChild]);

  const [status, setStatus] = useState(data.properties.value);

  const handleRadio = (e) => {
    setStatus((data.properties.value = e.target.value));
    setElement({ ...element });
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group mb-3 col-md-12 form-builder-element">
      <label htmlFor="">
        {element.properties.label}
        <If test={element?.properties?.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>

      <div className="row">
        {element.properties.options.map((v, k) => (
          <div key={k} className={"col-md-" + 12 / element.properties.columns}>
            <div className="custom-control custom-radio mb-3">
              <input
                onBlur={onBlurHandler}
                disabled={
                  data?.disableField &&
                  data?.properties?.value?.length !== 0 &&
                  localStorage.getItem("user.role") !== "admin"
                    ? data?.disableField
                    : readOnly ||
                      approve ||
                      !element.editable ||
                      (defValue && hasChiledReadOnly)
                }
                name={slugify(element.properties.label)}
                id={slugify(element.properties.label) + k}
                type="radio"
                className="custom-control-input form-view"
                label={element.properties.label}
                data={JSON.stringify(element)}
                value={v}
                onChange={handleRadio}
                checked={v === status}
                defaultValue={element.properties.value}
              />
              <label
                htmlFor={slugify(element.properties.label) + k}
                className={
                  "custom-control-label" + (foundError ? " error_radio" : "")
                }
              >
                {v}
              </label>
            </div>
          </div>
        ))}
        {foundError && (
          <span className="text-danger pl-3">{foundError?.value}</span>
        )}
      </div>
    </div>
  );
}

export default Radio;
